import { render, staticRenderFns } from "./StandardButtons.vue?vue&type=template&id=411e79bf&scoped=true&"
import script from "./StandardButtons.vue?vue&type=script&lang=js&"
export * from "./StandardButtons.vue?vue&type=script&lang=js&"
import style0 from "./StandardButtons.vue?vue&type=style&index=0&id=411e79bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411e79bf",
  null
  
)

component.options.__file = "StandardButtons.vue"
export default component.exports